import { Tooltip } from '@mui/material';
import { ReactElement } from 'react';
import { useKioskConnectivityStatusTooltipStyles } from './kiosk-connectivity-status-tooltip.styles';

export interface KioskConnectivityStatusTooltipProps {
  hubs: { name: string; message?: string }[];
  onOpen(): void;
}

export function KioskConnectivityStatusTooltip({
  hubs,
  onOpen,
  children
}: KioskConnectivityStatusTooltipProps & { children: ReactElement<any, any> }) {
  const classes = useKioskConnectivityStatusTooltipStyles();
  return (
    <Tooltip
      arrow
      classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}
      onOpen={onOpen}
      title={
        <div>
          <ul className={classes.list}>
            {hubs.map((hub) => (
              <li key={hub.name} className={classes.listItem}>
                {hub.name}
                {hub.message ? `: ${hub.message}` : null}
              </li>
            ))}
          </ul>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}
